import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/clases-de-contrataciones';

/**
 * GET Clases de Contrataciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getClasesDeContrataciones = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Clase de Contratacion
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getClaseDeContratacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Clase de Contratacion
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postClaseDeContratacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Clase de Contratacion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchClaseDeContratacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Clase de Contratacion
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteClaseDeContratacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
